// Side-effect модуль: регистрирует веб-платформу для ядра shared/.
// Обязан быть ПЕРВЫМ (и единственным статическим) импортом main.tsx и тестового setup — сторы shared/
// читают платформу при загрузке (см. install-order.test.ts).
import { configurePlatform } from '@shared/platform';
import { createWebPlatform } from './web';

configurePlatform(createWebPlatform());
